<angular-editor [style.--ae-text-area-bg-color]="bgColor" [config]="config" [placeholder]="placeholder" />
